import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Auth from "../api/auth";

const PrivateRoute = () => {
    if (!Auth.isLogged()) {
        return <Navigate exact to={`${process.env.PUBLIC_URL}/login`} />
    } else {
        return <Outlet />
    }
};

export default PrivateRoute;
